import { isEmpty, sanitizeValues } from '@intelligence/v3/utils/common';
import { getDefaultUrlFieldMap, getItemUrlParamsFieldMap } from '../shared/fieldMapUtils';
import { buildStringArrayApiParamsByItem } from '../shared/valueUtils';

import type { IFilterMiddlewareUtils } from '../shared/types';
import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';

const URL_FIELD = 'theme';
const URL_VALUE_JOINER = '$$';

const serializeThemeValue = (value: string): string => {
  return value.replace(/@/g, () => URL_VALUE_JOINER);
};

const getUrlField = (item: IFilterItemConfig, params?: unknown): string => {
  const urlParamsFieldMap = getItemUrlParamsFieldMap(item, params);
  const defaultUrlFieldMap = getDefaultUrlFieldMap(params);

  return urlParamsFieldMap.value || defaultUrlFieldMap.value || URL_FIELD;
};

/**
 * SensorTower 主题筛选器中间件工具
 * value 类型：string[]
 */
class SensorTowerThemeMiddlewareUtils implements IFilterMiddlewareUtils<string[], IRecord<string[]>> {
  convertToApiParams(item: IFilterItemConfig, filterValue?: string[], params?: unknown): IRecord<string[]> | null {
    return buildStringArrayApiParamsByItem(item, filterValue, params);
  }

  getManagedUrlKeys(item: IFilterItemConfig, params?: unknown): string[] {
    const field = getUrlField(item, params);

    return isEmpty(field) ? [] : [field];
  }

  deserializeUrlParams(item: IFilterItemConfig, searchParams: URLSearchParams, params?: unknown): string[] | null {
    if (isEmpty(searchParams)) {
      return null;
    }

    const field = getUrlField(item, params);
    const values = sanitizeValues(
      (searchParams.get(field) || '').split(',').map((itemValue) => itemValue.trim().replace(/\$\$/g, '@')),
    );

    return isEmpty(values) ? null : values;
  }

  serializeUrlParams(item: IFilterItemConfig, filterValue?: string[], params?: unknown): IRecord<string> | null {
    if (isEmpty(filterValue)) {
      return null;
    }

    const unique = sanitizeValues(filterValue).map(serializeThemeValue);
    const field = getUrlField(item, params);

    if (isEmpty(unique) || isEmpty(field)) {
      return null;
    }

    return {
      [field]: unique.join(','),
    };
  }
}

export default SensorTowerThemeMiddlewareUtils;
